// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21VnV","badges":"styles_badges__Xz2f1"};